// extracted by mini-css-extract-plugin
export var bodyFont = "index-module--body-font--8ecc5";
export var search_params = "index-module--search_params--67c80";
export var titleFont = "index-module--title-font--c02be";